<div class="content-blk">
  <div class="container">
    <h5 class="page-title">
      Manage Inventory

      <small class="pull-right title-link">
        <a [routerLink]="['/store/productlisting']">Warehouse Products</a>
      </small>
      <span class="clearfix"></span>
    </h5>

    <div class="add-product-dashboard">
      <div class="row">
        <div class="col-sm-4">
          Product:<strong class="text-info" style="cursor:pointer" (click)="fn_viewProductdetais(productID)">
            &nbsp;
            {{Title}}
            &nbsp;<i class="fa fa-external-link" aria-hidden="true" title="View Detailed version of the Product Basic info"></i>
          </strong><sup class="text-danger" *ngIf="isBulkOrderProduct">**Bulk Order</sup>
          <br />
          SKU#:<strong>&nbsp;{{SKU}}</strong>
          <br />
          Price(per piece):
          <strong *ngIf="!isBulkOrderProduct">&nbsp;{{Price | currency: "USD":"symbol":"1.2-4"}}</strong>
          <strong *ngIf="isBulkOrderProduct">&nbsp;{{minPrice | currency: "USD":"symbol":"1.2-4"}}</strong>
          <strong *ngIf="isBulkOrderProduct && maxPrice != minPrice">-{{maxPrice | currency: "USD":"symbol":"1.2-4"}}</strong>
        </div>
        <div class="col-sm-4">
          <strong *ngFor="let cat of Categories;let c=index">
            {{cat.CategoryName}}
            <br />
            <small *ngFor="let subCat of cat.SubCatetgoryList;let sc=index">
              &nbsp;
              <i class="fa fa-level-up collapsed-result" aria-hidden="true"></i>
              &nbsp;
              {{subCat.SubCategoryName}}<br />
            </small>
          </strong>
        </div>
        <div class="col-sm-4">
          <span (click)="fn_viewProductdetais(productID)">
            <span *ngFor='let img of imageList; let i = index;'>
              <img height="50" [src]="fn_GetImage(img)" class="product-wh-img" />
            </span>
            <br />
            <br />
            <span>View Details</span>
          </span>
        </div>
      </div>
    </div>

  
    <div class="white-background">
      <p>
        <small>
          <span class="text-danger"><b>Note: </b></span>
          If you leave price field empty it will use default price of the product. 
        </small>
      </p>
      <form [formGroup]="addInventoryDetails" (submit)="AddInventoryDetails(addInventoryDetails)" autocomplete="off">
        <p class="message-onway-count" *ngIf="TotalQuantityOnWay > 0">
          <ng-container *ngIf="!isBulkOrderProduct">
            You have sent <strong>{{TotalQuantityOnWay}}</strong> pieces of this product to the warehouse already, detailed description per variants is below.
          </ng-container>
          <ng-container *ngIf="isBulkOrderProduct">
            You have ordered <strong>{{TotalQuantityOnWay}}</strong> pieces of this product already, detailed description per variants is below.
          </ng-container>
        </p>
        <div class="table-responsive pro-tble-outer table-inventory-custom">
          <table class="table table-sm">
            <thead>
              <tr>
                <th width="15%">Color Name</th>
                <th width="15%">Hex Code</th>
                <th width="70%">
                  <table width="100%">
                    <thead>
                      <tr>
                        <th width="20%">Size</th>
                        <th width="20%"><abbr title="Current Quantity available at warehouse">In Stock Qty</abbr></th>
                        <th width="15%"><abbr title="Current Quantity sent for fullfillment at warehouse">Onway Qty</abbr></th>
                        <th width="15%"><abbr title="Previous price/size for the product variant">$ Current Price</abbr></th>
                        <th width="15%"><abbr title="Sending quantity to the warehouse">Add Qty</abbr></th>
                        <th width="15%"><abbr title="Set new price for the variant">$ Price</abbr></th>
                      </tr>
                    </thead>
                  </table>
                </th>
              </tr>
            </thead>
            <tbody formArrayName="Styles">
              <ng-container *ngFor="let row of addInventoryDetails.get('Styles')['controls']; let i = index" [formGroupName]="i">
                <tr>
                  <td width="15%">
                    <strong>{{row.controls.ColorName.value}}</strong> <!--Style-->
                  </td>
                  <td width="15%">
                    <p class="display-wh-colors" title="{{row.controls.ColorName.value}}" [ngStyle]="displayColor(row.controls.HexCode.value)">
                      &nbsp;
                    </p>
                    <span>&nbsp;{{row.controls.HexCode.value}}</span>
                  </td>
                  <ng-container formArrayName="Sizes">
                    <td width="70%">
                      <table width="100%" class="table table-sm table-inventory-custom-inner">
                        <tr *ngFor="let row2 of row.get('Sizes')['controls']; let j = index" [formGroupName]="j">
                          <td width="20%">
                            <strong class="invetory-size">{{row2.controls.SizeName.value}} </strong> <!--Size-->
                            <input type="hidden" formControlName="SizeName">
                          </td>
                          <td width="20%">
                            <strong>
                              {{row2.controls.StockOnHandQuantity.value}}
                            </strong>
                          </td>
                          <td width="15%">
                            <strong class="text-danger" title="Quantity to be reached at warehouse">
                              {{row2.controls.ProposedQuantity.value}}
                            </strong>
                          </td>
                          <td width="15%">
                            <strong>
                              {{row2.controls.CurrentPrice.value | currency: "USD":"symbol":"1.2-4"}}
                            </strong>
                          </td>
                          <td width="15%">
                            <input type="number" placeholder="Quantity" (change)="fn_calculateBulkPrice(row2.controls.Quantity.value,row2.controls.UnitPrice.value)" min="0" formControlName="Quantity">
                          </td>
                          <td width="15%">
                            <ng-container *ngIf="!isBulkOrderProduct">
                              <input type="number" placeholder="Unit Price" min="0" formControlName="UnitPrice">
                            </ng-container>
                            <ng-container *ngIf="isBulkOrderProduct">
                              <strong matToolTip="Price cannot be modify for bulk order product.">
                                {{row2.controls.UnitPrice.value | currency: "USD":"symbol":"1.2-4"}}
                              </strong>
                            </ng-container>                          
                          </td>
                        </tr>
                      </table>
                    </td>
                  </ng-container>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>
        <br />
        <div *ngIf="!flag" class="text-right sv-up-dt">
          <button *ngIf="!isBulkOrderProduct" class="mat-btn" mat-raised-button cdkFocusInitial [disabled]="addInventoryDetails.invalid">
            Submit
          </button>
          <button type="button" class="btn btn-light" *ngIf="isBulkOrderProduct" (click)="payNow(addInventoryDetails)">Pay Now</button>  
        </div>
        <div class="sctpay" *ngIf="flag">
          <h3 class="text-muted text-center">
            Make a Payment
          </h3>
          <br />

          <table align="center" class="payment-table">
            <tr>
              <td>
                <h6 class="text-info">Bulk Price</h6>
              </td>
              <td class="pull-right">
                <strong>{{total| currency:'USD':'symbol':'1.0-2'}}</strong>
              </td>
            </tr>
            <tr>
              <td>
                <h6 class="text-info">Bulk Disount</h6>
              </td>
              <td class="pull-right"><strong><span class="text-danger">(-)&nbsp;</span>{{discountedPrice| currency:'USD':'symbol':'1.0-2'}}</strong></td>
            </tr>
            <tr>
              <td colspan="2">
                <hr />
              </td>
            </tr>
            <tr>
              <td>
                <h6 class="text-info font-25">Total Amount</h6><br />
              </td>
              <td class="pull-right">
                <strong class="font-25">{{totalCosttoCharge| currency:'USD':'symbol':'1.0-2'}}</strong>
              </td>
            </tr>
          </table>
          <small class="text-info">Proceed to pay the amount of <strong class="font-25">{{totalCosttoCharge| currency:'USD':'symbol':'1.0-2'}}</strong> for bulk order.</small>
          <br /><br />
          <div class="text-center">
            <ngx-paypal [config]="payPalConfig"></ngx-paypal>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<br />
<br />
<br />
